import { createOwnUpStyle } from '../../components/style';
import './fonts.styl';
/**
 * Mixin to apply the Graphik Semi-Bold font.
 */

export var GRAPHIK_SEMIBOLD = createOwnUpStyle({
  fontFamily: 'Graphik-Semibold',
  fontWeight: 'normal',
  fontStyle: 'normal',
  fontStretch: 'normal'
});
/**
 * Mixin to apply the Graphik Medium font.
 */

export var GRAPHIK_MEDIUM = createOwnUpStyle({
  fontFamily: 'Graphik-Medium',
  fontWeight: 'normal',
  fontStyle: 'normal',
  fontStretch: 'normal'
});
/**
 * Mixin to apply the Graphik Regular font.
 */

export var GRAPHIK_REGULAR = createOwnUpStyle({
  fontFamily: 'Graphik-Regular',
  fontWeight: 'normal',
  fontStyle: 'normal',
  fontStretch: 'normal'
});
/**
 * Mixin to apply the Graphik Regular font.
 */

export var MONOSTEN_BOLD = createOwnUpStyle({
  fontFamily: 'Monosten-Bold',
  fontWeight: 'normal',
  fontStyle: 'normal',
  fontStretch: 'normal'
});
/**
 * Mixin to apply the Graphik Regular font.
 */

export var MONOSTEN_LIGHT = createOwnUpStyle({
  fontFamily: 'Monosten-Light',
  fontWeight: 'normal',
  fontStyle: 'normal',
  fontStretch: 'normal'
});
/**
 * Mixin to apply the Graphik Regular font.
 */

export var MONOSTEN_MEDIUM = createOwnUpStyle({
  fontFamily: 'Monosten-Medium',
  fontWeight: 'normal',
  fontStyle: 'normal',
  fontStretch: 'normal'
});
/**
 * Mixin to apply the Tiempos Headline Medium font.
 */

export var TIEMPOS_HEADLINE_REGULAR = createOwnUpStyle({
  fontFamily: 'TiemposHeadline-Regular',
  fontWeight: 'normal',
  fontStyle: 'normal',
  fontStretch: 'normal'
});
/**
 * Mixin to apply the Tiempos Headline Medium font.
 */

export var TIEMPOS_HEADLINE_MEDIUM = createOwnUpStyle({
  fontFamily: 'TiemposHeadline-Medium',
  fontWeight: 'normal',
  fontStyle: 'normal',
  fontStretch: 'normal'
});